export default __webpack_public_path__ + "static/media/2SiteCooperando_Desktop_Onda.b91f9494.png";